import { apiClient } from "./client";

// Фінансова зведена по сегментах (FR-FIN):
// Виручка → COGS → Gross Margin → SG&A → EBITDA.

export interface FinanceSegment {
  key: string;      // 'kgu' | 'solar:<uuid>'
  name: string;
  kind: "kgu" | "solar";
  revenue_uah: number | string;
  cogs_uah: number | string;
  gross_margin_uah: number | string;
  sga_uah: number | string;
  ebitda_uah: number | string;
  breakdown: Record<string, number | string>;
}

export interface FinanceSummary {
  from_date: string;
  to_date: string;
  sga_total_uah: number | string;
  segments: FinanceSegment[];
  ebitda_total_uah: number | string;
  ebitda_kgu_uah: number | string;
  ebitda_solar_uah: number | string;
}

export const financeApi = {
  summary: (from: string, to: string) =>
    apiClient
      .get<FinanceSummary>("/finance/summary", { params: { from, to } })
      .then((r) => r.data),
  daily: (from: string, to: string) =>
    apiClient
      .get<FinanceDay[]>("/finance/daily", { params: { from, to } })
      .then((r) => r.data),
};

export interface FinanceDaySegment {
  key: string;
  name: string;
  kind: "kgu" | "solar";
  revenue_uah: number | string;
  cogs_uah: number | string;
  /** Прибуток ДО SG&A (виручка − прямі витрати сегмента). */
  profit_uah: number | string;
  /** Розкладка прямих витрат: gas / rent / service / consumables / other / imbalance. */
  costs: Record<string, number | string>;
  /** Частка SG&A доби — у profit_uah не входить, вмикається фільтром. */
  sga_uah: number | string;
}

/** Статті, які можна вмикати/вимикати на графіку з фільтрами. */
export const COST_GROUPS = [
  "gas",
  "rent",
  "service",
  "consumables",
  "other",
  "imbalance",
  "sga",
] as const;
export type CostGroup = (typeof COST_GROUPS)[number];

export interface FinanceDay {
  day: string;
  segments: FinanceDaySegment[];
  /** План є лише у КГУ — у СЕС планування немає. */
  plan_profit_kgu_uah: number | string | null;
}
